<template>
  <div
    itemscope
    itemtype="http://schema.org/Product"
    class="perfume-card"
    @click="$emit('click', data)"
  >
    <FamiliesWithIcon
      itemprop="additionalProperty"
      :family="data.family"
      :subfamily="data.secondaryFamily"
    ></FamiliesWithIcon>
    <div
      class="image"
      :style="{ backgroundImage: `url(${data.imageUrl})` }"
    ></div>
    <div itemprop="name" class="name">{{ data.name }}</div>
    <div itemprop="brand" class="brand">{{ data.brand.name }}</div>
    <div
      class="remove-button"
      v-if="showRemove"
      @click.stop="$emit('remove', data)"
    ></div>
  </div>
</template>

<script>
import FamiliesWithIcon from "@/components/wikiparfum/FamiliesWithIcon";
export default {
  name: "PerfumeCard",
  components: {
    FamiliesWithIcon,
  },
  props: ["data", "showRemove"],
  methods: {},
};
</script>

<style scoped lang="stylus">
.perfume-card
  align-items: center
  background-color: #fff
  border: 1px solid rgba(#000, 0.15)
  cursor: pointer
  display: flex
  flex-direction: column
  overflow: hidden
  padding: vw(10px)
  position: relative

  .mobile &
    padding: vw(20px)

    @media (max-width: 375px)
      padding: vw(60px)

  .image
    background-position: center center
    background-repeat: no-repeat
    background-size: contain
    height: 400px
    margin: vh(10px) 0
    width: 400px

    .mobile &
      flex: 1 1 0%
      width: 100%

  .name
    m-ellipsis(100%)
    m-font-size(14, 20)
    font-weight: 500

    .mobile &
      m-font-size(16, 20)
      margin-bottom: vw(5px)
      margin-top: vw(20px)

      @media (max-width: 375px)
        m-font-size(26, 30)
        margin-bottom: vw(10px)
        margin-top: vw(40px)

  .brand
    m-ellipsis(100%)
    m-font-size(11, 13)
    text-transform: uppercase

    .mobile &
      @media (max-width: 375px)
        m-font-size(20, 24)

  .remove-button
    m-icon("close", 15)
    cursor: pointer
    position: absolute
    right: vw(4px)

  .family-and-icon
    width: 100%
</style>